import { Building2, ShoppingCart, User } from 'lucide-react'
import Card from '../../../components/common/Card'
import { BusinessType } from './BusinessDetail'

const ClientCompanyDetail = ({ data }: { data: BusinessType }) => {
    return (
        <Card>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-4'>
                {/* Produtos */}
                <div>
                    <div className='flex items-center gap-1 mb-4 border-b border-gray-200 dark:border-gray-600 pb-3'>
                        <ShoppingCart className='w-5 h-5' />
                        <h4 className='font-bold'>Produtos</h4>
                    </div>
                    <div className='space-y-1'>
                        {data.products &&
                            data.products.map((product: any, index: number) => (
                                <p key={index} className='font-medium'>
                                    {product.name || 'Produto não informado!'}
                                </p>
                            ))}
                    </div>
                </div>

                {/* Empresa */}
                <div>
                    <div className='flex items-center gap-1 mb-4 border-b border-gray-200 dark:border-gray-600 pb-3'>
                        <Building2 className='w-5 h-5' />
                        <h4 className='font-bold'>Empresa</h4>
                    </div>
                    <div className='space-y-1'>
                        <p className='font-medium'>{data.company.name || 'Empresa não informada!'}</p>
                        {data.company?.email && <p>{data.company?.email}</p>}
                    </div>
                </div>

                {/* Contatos */}
                <div>
                    <div className='flex items-center gap-1 mb-4 border-b border-gray-200 dark:border-gray-600 pb-3'>
                        <User className='w-5 h-5' />
                        <h4 className='font-bold'>Contatos</h4>
                    </div>
                    <div className='space-y-1'>
                        {data.contacts &&
                            data.contacts.map((contact: any, index: number) => (
                                <div key={index}>
                                    <p className='font-medium'>{contact.name || 'Contato não informado!'}</p>
                                    {contact?.email && <p>{contact?.email}</p>}
                                    {contact?.phone && <p>{contact?.phone}</p>}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default ClientCompanyDetail
